import React, { useEffect, useState } from "react";
import SEO from "../../data/seo";
import HeaderTwo from "../../layout/headers/header-two";
import FooterTwo from "../../layout/footers/footer-two";
import BreadCrumb from "../common/breadcrumb";
import { useParams, useNavigate } from "react-router-dom";
import RecruitmentSingleMain from "./recruitment-single";
import {getRecruitments} from "../../utils/cms.utils";

const RecruitmentDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [singleData, setSingleData] = useState(null);

    useEffect(() => {
        const data = getRecruitments();
        const items = Array.isArray(data) ? data : [];

        const found = items.find(
            (item) => String(item.id) === String(id)
        );

        if (!found) {
            navigate("/404-error", { replace: true });
            return;
        }

        setSingleData(found);
    }, [id, navigate]);

    if (!singleData) return null;

    const breadcrumbTitle =
        singleData?.positionEn?.split(" ").slice(0, 3).join(" ") + "...";

    return (
        <>
            <SEO pageTitle={singleData?.positionEn} />
            <HeaderTwo />

            <BreadCrumb
                title={breadcrumbTitle}
                items={[
                    { label: "Careers", to: "/recruitment" },
                    { label: breadcrumbTitle },
                ]}
            />

            <RecruitmentSingleMain singleData={singleData} />

            <FooterTwo />
        </>
    );
};

export default RecruitmentDetails;
